const translations = {
  about: 'Par TOP3',
  appName: 'TOP3',
  data: 'Data',
  tasks: 'Uzdevumi',
  'tasks.create_title': 'Izveidot jaunu uzdevumu',
  'task.removed': 'Uzdevums tika noņemts',
  logout: 'Izlogoties',
  password: 'Parole',
  email: 'Nosūtīt',
  login: 'Pieslēgties',
  loginError: 'E-pasta vai parole ir nepareiza',
  pleaseWait: 'Lūdzu uzgaidiet...',
  loggedOut: 'Jūs esat veiksmīgi pieteicies no sistēmas!',
  monday: 'Pirmdiena',
  tuesday: 'Otrdiena',
  wednesday: 'Trešdiena',
  thursday: 'Ceturtdiena',
  friday: 'Piektdiena',
  saturday: 'Saturday',
  sunday: 'Sunday',
  header: 'Uzdevums',
  type: 'Tips',
  typeActivity: 'Aktivitāte',
  typeBoard: 'Personāls / Management',
  typeDevelopment: 'Stratēģiskā attīstība',
  task: 'Uzdevums',
  plannedResult: 'Mērķis',
  achievedResult: 'Rezultāts',
  rating: 'Reitings',
  ratingMet: 'Apmierinošs',
  ratingNotMet: 'Neapmierinoši',
  ratingAverage: 'Vidējais',
  save: 'Save',
  cancel: 'Atcelt',
  date: 'Datums',
  weekday0: 'Pirmdiena',
  weekday1: 'Otrdiena',
  weekday2: 'Trešdiena',
  weekday3: 'Ceturtdiena',
  weekday4: 'Piektdiena',
  weekday5: 'Saturday',
  weekday6: 'Sunday',
  week: 'Nedēļa',
  user: 'Darbinieku',
  'user.filter': 'Meklēt darbinieks ...',
  noResults: 'Nav atrasts',
  comments: 'Komentāri',
  delete: 'Remove',
  confirmTaskDelete: 'Vai tiešām vēlaties noņemt šo uzdevumu?',
  myTasks: 'Mani uzdevumi',
  sessionExpired: 'Sesija beigusies. Lūdzu pieteikties vēlreiz.',
  attachFile: 'Pievienot failu',
  confirmCommentDelete: 'Vai tiešām vēlaties noņemt šo komentāru?',
  commentEmail: 'Komentārs tika nosūtīta uz e-pastu',
  required: 'Šis lauks ir obligāts',
  'comment.tooltip': 'Pievienot komentāru',
  'groups.title': 'Grupas',
  'group.title': 'Grupa',
  'groups.edit_title': 'Edit group',
  'groups.create_title': 'Izveidot grupu',
  'groups.delete_title': 'Noņemt grupu',
  'groups.id': 'Nē.',
  'groups.name': 'Nosaukums',
  'groups.ownerId': 'Vadītājs',
  'groups.changeOwner': 'Izvēlieties vadītājs ...',
  'groups.find': 'Meklēt grupu ...',
  'group.members': 'Biedri',
  'group.guests': 'Viesi',
  'group.addMember': 'Pievienot dalībnieku',
  'group.addGuest': 'Pievienot viesis',
  'group.noMembers': 'Neviens ir pievienots',
  'group.confirmDelete': 'Vai tiešām vēlaties noņemt šo grupu?',
  'users.title': 'Lietotāji',
  'user.title': 'Lietotājs',
  'user.profile': 'Mans profils',
  'user.modify.title': 'Edit lietotājs',
  'users.create.tooltip': 'Izveidot lietotāju',
  'users.delete_title': 'Noņemt lietotāju',
  'user.created': 'Naudotojas sukurtas',
  'user.updated': 'Naudotojas pakeistas',
  'user.removed': 'Naudotojas pašalintas',
  'users.id': 'Nē.',
  'user.name': 'Nosaukums',
  'user.surname': 'Uzvārds',
  'user.role': 'Loma',
  'user.role.ADMIN': 'Administrators',
  'user.role.USER': 'Lietotājs',
  'user.role.undefined': 'Nav',
  'user.email': 'Nosūtīt',
  'user.email.unique': 'E-pasta ir unikāls',
  'user.username': 'Lietotājvārds',
  'user.username.unique': 'Lietotājvārds ir unikāls',
  'user.password': 'Lietotājs parole',
  'user.members': 'Dalībvalstis grupās',
  'user.guests': 'Viesu grupās',
  'user.addGroup': 'Pievienot grupu',
  'user.noMembers': 'Neviens ir pievienots',
  'user.delete.confirm': 'Vai tiešām vēlaties noņemt šo lietotāju?',
  'user.language.select': 'Valoda',
  'user.language.EN': 'English',
  'user.language.ES': 'Ispano',
  'user.language.PL': 'Polskie',
  'user.language.RU': 'Русский',
  'user.language.LT': 'Lietuvių',
  'user.language.LV': 'Latviešu',
  'user.language.EE': 'Eesti',
  'user.view.edit': 'Redaguoti naudotoją',
  'user.role.select': 'Rolė',
  'user.save.tooltip': 'Išsaugoti naudotoją',
  'user.cancel.modify.tooltip': 'Atšaukti',
  'user.password.change.save.tooltip': 'Išsaugoti naują slaptažodį',
  'user.password.change.cancel.tooltip': 'Atšaukti',
  'user.view.change.password': 'Mainīt paroli',
  'user.password.change.title': 'Paroles maiņa',
  'user.password.old': 'Vecā parole',
  'user.password.new1': 'Jauna parole',
  'user.password.new2': 'Atkārtot jauno paroli',
  'user.password.change.mismatch': 'Paroles nav atbilstošas',
  'about.title': 'Par TOP3',
  'about.tagline': 'Nospiežot šo pogu, jūs lejupielādēt aprakstu par TOP3 sistēmas',
  'about.action': 'Lejupielādēt',
  'about.text': 'Mēs gaidām jautājumus un novērojumus mūsu sistēmu '
    + '<a href="mailto:pagalba@axis.lt">pagalba@axis.lt</a> .',
  'user.password.changed': 'Password mainīts.',
  'user.password.change.failed': 'Neizdevās nomainīt paroli. Ņemot parole incorect.',
  dashboard: 'Grafikas',
  'dashboard.generate': 'Generuoti',
  'dashboard.saveAsImage': 'Siųstis',
  'dashboard.exportToExcel': 'Exportuoti į Excel',
  'dashboard.dataZoom': 'Priartinti',
  'dashboard.dataZoomReset': 'Gražinti praeitą vaizdą',
  'dashboard.restore': 'Atstatyti pradinį vaizdą',
  'dashboard.noData': 'Nėra duomenų',
  'dashboard.data.title': 'Grafikas',
  'dashboard.data.dateFrom': 'Laikotarpis nuo (imtinai)',
  'dashboard.data.dateTo': 'Laikotarpis iki (imtinai)',
  'dashboard.data.unit': 'Matavimo vienetas',
  'dashboard.data.unit.WEIGHT': 'Svoris, t',
  'dashboard.data.unit.VOLUME': 'Tūris, m3',
  'dashboard.data.unit.VOLUME_AT_15C': 'Tūris prie 15°C, m3',
  'dashboard.data.exportToExcel': 'Excel',
  'dashboard.data.reportdate': 'Laikas',
  'dashboard.data.official': 'Buhalterija',
  'dashboard.data.fact': 'Faktinis',
  'dashboard.data.factFrom': 'Faktinis nuo',
  'dashboard.data.factTo': 'Faktinis iki',
  'dashboard.data.factPart5': 'Talpykla5',
  'dashboard.data.factPart6': 'Talpykla6',
  'dashboard.data.diff': 'Skirtumas',
  'dashboard.data.counter': 'Skaitiklis',
  'dashboard.data.counterDiff': 'Skaitiklio skirtumas',
  // product form generic
  products: 'Produktai',
  'products.title': 'Produktai',
  'product.title': 'Produktas',
  'product.delete.confirm': 'Ar tikrai norite pašalinti produktą',
  'product.updated': 'Produktas atnaujintas',
  'product.created': 'Produktas sukurtas',
  'product.filter': 'Ieškoti produkto...',
  'product.save.tooltip': 'Išsaugoti produktą',
  'product.modify.title': 'Produktas',
  'product.cancel.modify.tooltip': 'Atšaukti redagavimą',
  'product.create.title': 'Produkto kūrimas',
  'product.cancel.create.tooltip': 'Atšaukti kūrimą',
  'product.create.tooltip': 'Kurti produktą',
  // product form specific
  'product.type': 'Produktas',
  'product.description': 'Aprašymas',
  'product.shortDescription': 'Trumpas aprašymas',
  'product.classificator': 'Klasifikatorius',
  'product.tarrifGroupCode': 'Tarifinė grupė',
  'product.materialType': 'Produkto rūšis',
  'product.name.unique': 'Produkto pavadinimas turi būti unikalus',

  // driver form generic
  drivers: 'Vairuotojai',
  'drivers.title': 'Vairuotojai',
  'driver.title': 'Vairuotojas',
  'driver.create.tooltip': 'Kurti Vairuotoją',
  'driver.updated': 'Vairuotojas atnaujintas',
  'driver.created': 'Vairuotojas sukurtas',
  'driver.removed': 'Vairuotojas pašalintas',
  'driver.filter': 'Ieškoti vairuotojo...',
  'driver.save.tooltip': 'Išsaugoti vairuotoją',
  'driver.modify.title': 'Vairuotojo redagavimas',
  'driver.create.title': 'Vairuotojo kūrimas',
  'driver.cancel.modify.tooltip': 'Atšaukti redagavimą',
  'driver.cancel.create.tooltip': 'Atšaukti kūrimą',
  'driver.delete.confirm': 'Ar tikrai norite pašalinti vairuotoją',
  // driver form specific
  'driver.fullName': 'Vairuotojo vardas pavardė',
  'driver.adrNo': 'Vairuotojo ADR numeris',
  'driver.adrDate': 'Vairuotojo ADR galiojimo data',

  // company form generic
  companies: 'Įmonės',
  'companies.title': 'Įmonės',
  'company.title': 'Įmonė',
  'company.create.tooltip': 'Kurti Įmonę',
  'company.updated': 'Įmonė atnaujinta',
  'company.created': 'Įmonė sukurta',
  'company.removed': 'Įmonė pašalinta',
  'company.filter': 'Ieškoti įmonės ...',
  'company.save.tooltip': 'Išsaugoti įmonę',
  'company.modify.title': 'Įmonės redagavimas',
  'company.create.title': 'Įmonės kūrimas',
  'company.cancel.modify.tooltip': 'Atšaukti redagavimą',
  'company.cancel.create.tooltip': 'Atšaukti kūrimą',
  'company.delete.confirm': 'Ar tikrai norite pašalinti įmonę ?',
  // company form specific
  'company.name': 'Pavadinimas',
  'company.address': 'Adresas',
  'company.vatCode': 'PVM kodas',
  'company.country': 'Valstybė',
  'company.companyCode': 'Įmonės kodas',
  'company.exciseWhNo': 'Akcizinio sandėlio Nr.',
  'company.additionalInformation': 'Papildoma informacija',
  'company.companyCode.unique': 'Įmonės kodas turi būti unikalus',
  'company.code.unique': 'Įmonės kodas turi būti unikalus',
  'country.select': 'Valstybė',
  'company.whClient': 'Sandėlio klientas',

  // tank form generic
  tanks: 'Talpyklos',
  'tanks.title': 'Talpyklos',
  'tank.create.tooltip': 'Sukurti talpyklą',
  'tank.updated': 'Talpykla atnaujinta',
  'tank.created': 'Talpykla sukurta',
  'tank.removed': 'Talpykla pašalinta',
  'tank.filter': 'Ieškoti talpyklos...',
  'tank.save.tooltip': 'Išsaugoti talpyklą',
  'tank.modify.title': 'Talpyklos redagavimas',
  'tank.create.title': 'Talpyklos kūrimas',
  'tank.cancel.modify.tooltip': 'Atšaukti redagavimą',
  'tank.cancel.create.tooltip': 'Atšaukti kūrimą',
  'tank.delete.confirm': 'Ar tikrai norite pašalinti talpyklą ?',
  // tank form specific
  'tank.name': 'Talpyklos pavadinimas',
  'tank.capacity.ltr': 'Talpa litrais (l)',
  'tank.capacity.kg': 'Talpa kilogramais (kg)',
  'tank.material': 'Produktas',
  'tank.name.unique': 'Talpyklos pavadinimas turi būti unikalus',
  'material.select': 'Produktas',

  // transport form generic
  transports: 'Transporto priemonės',
  'transports.title': 'Transporto priemonės',
  'transport.title': 'Transporto priemonė',
  'transport.create.tooltip': 'Kurti Transporto priemonę',
  'transport.updated': 'transporto priemonė atnaujinta',
  'transport.created': 'Transporto priemonė sukurta',
  'transport.removed': 'Transporto priemonė pašalinta',
  'transport.filter': 'Ieškoti transporto priemonės',
  'transport.save.tooltip': 'Saugoti transporto priemonę',
  'transport.edit.title': 'Transporto priemonės redagavimas',
  'transport.create.title': 'Transporto priemonės kūrimas',
  'transport.cancel.modify.tooltip': 'Atšaukti',
  'transport.delete.confirm': 'Ar tikrai norite pašalinti transporto priemonę',
  // transport form specific
  'transportType.select': 'Tipas',
  'transport.name.unique': 'Transporto priemonės numeris turi būti unikalus',
  'transports.description': 'Apibūdinimas',
  'transports.brand': 'Markė',
  'transports.model': 'Modelis',
  'transports.adrNo': 'ADR numeris',
  'transports.adrDate': 'ADR galiojimo data',
  'transports.segments': 'Segmentų talpos',
  'transports.segmentNo': 'Segmento Nr.',
  'transports.capacityLtr': 'Segmento talpa, l',
  'transport.segment.add': 'Pridėti segmentą',
  'transport.segment.remove': 'Pašalinti segmentą',
  'transport.identificationNo': 'Numeris',
};

export default translations;